import {
  AlertIssuedWithErrorsFinancialDocumentEventFragment,
  FinanceValueObjectsFinancialDocumentEventTypeEnum,
  FinancialDocumentEventFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const mapEventTypeIcon = (key: FinanceValueObjectsFinancialDocumentEventTypeEnum) => {
  switch (key) {
    case 'created':
      return 'pencil'
    case 'registered':
      return 'timer'
    case 'tax_document_formatted':
      return 'file-filled'
    case 'tax_document_delivered':
      return 'envelope'
    case 'issued':
      return 'check-circle-line'
    case 'resetted_registered':
      return 'refresh'
    default:
      return key satisfies never
  }
}

export const mapEventText = (key: FinanceValueObjectsFinancialDocumentEventTypeEnum) => {
  switch (key) {
    case 'created':
      return i18n.t('finance.sale_invoices.detail.events_type.created')
    case 'registered':
      return i18n.t('finance.sale_invoices.detail.events_type.registered')
    case 'tax_document_formatted':
      return i18n.t('finance.sale_invoices.detail.events_type.tax_document_formatted')
    case 'tax_document_delivered':
      return i18n.t('finance.sale_invoices.detail.events_type.tax_document_delivered')
    case 'issued':
      return i18n.t('finance.sale_invoices.detail.events_type.issued')
    case 'resetted_registered':
      return i18n.t('finance.sale_invoices.detail.events_type.resetted_registered')
    default:
      return key satisfies never
  }
}

export const getEventErrorMessage = (event: FinancialDocumentEventFragment) => {
  const parts = [i18n.t('finance.sale_invoices.detail.event_status.error')]

  if (event.code) parts.push(event.code)
  if (event.message) parts.push(`- ${event.message}`)

  return parts.join(' ')
}

export const issuedWithErrors = (
  validated?: boolean,
  events?: AlertIssuedWithErrorsFinancialDocumentEventFragment[]
) => {
  const errorEvent = events?.find(
    (event) => event.status === 'error' && event.type == 'tax_document_delivered'
  )
  return validated && errorEvent
}
